import { ErrorMessage, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  Input,
  SelectInput,
} from "../../../../../_metronic/_partials/controls";
import API from "../../../../helpers/devApi";
import * as Yup from "yup";
import * as Action from "../../../applicant/_redux/applicantActions";
import { swalConfirm, swalError, swalSuccess } from "../../../../helpers/swal";

const _init = {
  language: "",
  writing: "",
  speaking: "",
  reading: "",
};

const languageOptions = [
  {
    value: "English",
    label: "English",
  },
  {
    value: "Bangla",
    label: "Bangla",
  },
  {
    value: "Hindi",
    label: "Hindi",
  },
  {
    value: "Other",
    label: "Other",
  },
];

const lavels = [
  {
    value: "Native",
    label: "Native",
  },
  {
    value: "Fluent",
    label: "Fluent",
  },
  {
    value: "Intermediate",
    label: "Intermediate",
  },
];

const Language = ({ id }) => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [languageData, setLanguageData] = useState();
  const { languageList } = useSelector(
    ({ applicant }) => ({
      languageList: applicant.languageList,
    }),
    shallowEqual
  );

  useEffect(() => {
    if (id) {
      dispatch(Action.getLanguageListForApplicant(id));
    }
  }, [dispatch, id]);

  useEffect(() => {
    if (languageList && languageList.length > 0) {
      const data = languageList?.map((item) => {
        return {
          id: item?.hrms_language_proficiency__id,
          language: item?.hrms_language_proficiency__language,
          writing: item?.hrms_language_proficiency__writing,
          speaking: item?.hrms_language_proficiency__speaking,
          reading: item?.hrms_language_proficiency__reading,
        };
      });
      setLanguageData({ list: data });
    } else {
      setLanguageData({ list: [_init] });
    }
  }, [languageList]);

  // Validation schema
  const validationSchema = Yup.object().shape({
    list: Yup.array().of(
      Yup.object().shape({
        language: Yup.string().required("language is required"),
        writing: Yup.string().required("writing is required"),
        speaking: Yup.string().required("speaking is required"),
        reading: Yup.string().required("reading is required"),
      })
    ),
  });
  const handleSaveProfile = async (values) => {
    const formData = values?.list?.map((item) => {
      return {
        language: item?.language,
        writing: item?.writing,
        speaking: item?.speaking,
        reading: item?.reading,
      };
    });

    if (id && formData?.length > 0) {
      await API.patch(`/hrms_language_proficiency/bulkUpdate/${id}`, formData)
        .then(async (res) => {
          if (res.data.success) {
            if (formData.length) {
              dispatch(
                Action.createProfileScore(
                  {
                    name: ["Language"],
                    applicant_id: id,
                  },
                  async () => {
                    await dispatch(Action.getLanguageListForApplicant(id));
                    dispatch(Action.getApplicantPersonalInfo(id));
                  }
                )
              );
            } else {
              dispatch(
                Action.updateProfileScore(
                  {
                    name: ["Language"],
                    applicant_id: id,
                  },
                  async () => {
                    await dispatch(Action.getLanguageListForApplicant(id));
                    dispatch(Action.getApplicantPersonalInfo(id));
                  }
                )
              );
            }
            swalSuccess("Language Updated Successfully!!");
            setLoading(false);
          } else {
            swalError("something went wrong");
          }
        })
        .catch((error) => {
          console.error(error);
        });
      setLoading(false);
    }
  };

  const handleDeleteLanguage = async (itemId, index) => {
    swalConfirm().then(async (res) => {
      if (res.isConfirmed) {
        const list = languageData?.list;
        list.splice(index, 1);
        setLanguageData({ list: list });

        // if (itemId) {
        //     await API.delete(
        //         `/sys_users/hrms_language_proficiency/delete/inCareerPortal/${itemId}`
        //     );
        //     dispatch(Action.getLanguageListForApplicant(id));
        // }
      }
    });
  };
  const handleAddLanguage = async (values) => {
    // const list = languageData?.list;
    // let data = [...list, _init];
    const newArray = [...values.list];
    let data = [...newArray, _init];
    setLanguageData({ list: data });
  };

  return (
    <div className="card card_body_box mb-5">
      <Formik
        initialValues={languageData}
        enableReinitialize={true}
        validationSchema={validationSchema}
        onSubmit={async (values) => {
          await handleSaveProfile(values);
        }}
      >
        {({
          handleSubmit,
          setFieldValue,
          values,
          errors,
          touched,
          isSubmitting,
        }) => (
          <Form>
            <div className="row">
              <div className="col-md-12">
                <div className="card_header_with_edit_btn">
                  <div className="title">
                    <h2>Languages</h2>
                  </div>
                </div>

                <hr />
              </div>
            </div>
            {values?.list?.map((item, i, row) => (
              <div className="row" key={i}>
                <div className="col-md-12 mb-4">
                  <div className="card">
                    <div className="card-body">
                      <div className="row">
                        <div className="col-md-6 mb-3">
                          <Input
                            name={`list[${i}].language`}
                            label={"Language"}
                            options={languageOptions}
                            isRequired
                            onChange={(e) => {
                              setFieldValue(
                                `list[${i}].language`,
                                e.target.value
                              );
                            }}
                            value={item.language}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].language`} />
                          </div>
                        </div>
                        <div className="col-md-6 mb-3">
                          <SelectInput
                            name={`list[${i}].writing`}
                            label={"Writing"}
                            options={lavels}
                            isRequired
                            onChange={(value) => {
                              setFieldValue(`list[${i}].writing`, value);
                            }}
                            value={item.writing}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].writing`} />
                          </div>
                        </div>

                        <div className="col-md-6 mb-3">
                          <SelectInput
                            name={`list[${i}].speaking`}
                            label={"Speaking"}
                            options={lavels}
                            isRequired
                            onChange={(value) => {
                              setFieldValue(`list[${i}].speaking`, value);
                            }}
                            value={item.speaking}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].speaking`} />
                          </div>
                        </div>

                        <div className="col-md-6 mb-3">
                          <SelectInput
                            name={`list[${i}].reading`}
                            label={"Reading"}
                            options={lavels}
                            isRequired
                            onChange={(value) => {
                              setFieldValue(`list[${i}].reading`, value);
                            }}
                            value={item.reading}
                          />
                          <div className="text-danger">
                            <ErrorMessage name={`list[${i}].reading`} />
                          </div>
                        </div>
                        <div className="col-md-6 mb-3 d-flex">
                          {i === values?.list?.length - 1 && (
                            <button
                              className="btn  add-button btn-sm text-white mr-5 text-nowrap"
                              onClick={() => {
                                handleAddLanguage(values);
                              }}
                            >
                              <i
                                className="fa fa-plus text-white"
                                aria-hidden="true"
                              ></i>
                              Add Language
                            </button>
                          )}

                          <button
                            className="btn btn-danger btn-sm  text-nowrap"
                            disabled={row.length == 1}
                            type="button"
                            onClick={() => {
                              handleDeleteLanguage(item.id, i);
                            }}
                          >
                            <i
                              className="fa fa-minus  text-white"
                              aria-hidden="true"
                            ></i>
                            Remove Language
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
            <div className="edit_btn_group d-flex modal-footer m-0 p-0">
              {/* <button className='btn btn-default mr-4' >Cancel</button> */}
              <button
                type="submit"
                className="btn btn-primary"
                onClick={handleSubmit}
                disabled={isSubmitting}
              >
                {isSubmitting && <i className="fa fa-sync fa-spin"></i>} Save
              </button>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default Language;
